<template>
  <div class="areal">
    <h2 class="h2">Výber apartmánov</h2>
    <img
        id="map"
        src="/img/visualization/building.jpg"
        usemap="#map"
        alt=""
        class="areal__img"
    />

    <map name="map">
      <area
          v-for="floor in floors"
          :key="floor.id"
          :coords="floor.coords"
          :data-key="floor.id"
          :href="'/ponuka-bytov/' + floor.pattern"
          shape="poly"
          @click="toggleFloor(floor)"
          @mouseover="showPointer(floor, $event)"
          @mousemove="movePointer"
          @mouseleave="areaHover = false"
      />
    </map>

    <!-- <div class="pt-3 pb-5 text-center">
            <span class="own-btn own-btn--primary own-btn--text"
                >Vyberte si poschodie</span
            >
        </div> -->

    <teleport to="body">
      <pointer
          v-if="areaHover"
          :data="areaHoverData"
          :posY="pointerPosY"
          :posX="pointerPosX"
      ></pointer>
    </teleport>
  </div>
</template>

<script>
import mapster from "imagemapster";
import $ from 'jquery';

export default {
  props: {
    floors: Array | Object,
  },
  data() {
    return {
      areaHover: false,
      areaHoverData: null,
      pointerPosY: 0,
      pointerPosX: 0,
    };
  },
  inject: ['toggleFloor'],
  methods: {
    showPointer(item, event) {
      this.areaHoverData = item;
      this.areaHover = true;
      // this.pointerPosX = event.pageX;
      // this.pointerPosY = event.pageY;
    },
    movePointer(event) {
      if (this.areaHover) {
        let moveUp;
        let moveLeft;
        if (event.pageX > 900) {
          moveLeft = 450;
        } else {
          moveLeft = 100;
        }
        if (event.pageY < 200) {
          moveUp = 100;
        } else {
          moveUp = 200;
        }
        this.pointerPosY = event.pageY;
        this.pointerPosX = event.pageX;
      }
    },
  },
  mounted() {
    this.$nextTick(function () {
      let floors = this.floors;
      let that = this;

      function createAreas() {
        var output = [];
        // Pozemky
        for (let a = 0; a < floors.length; a++) {
          output.push({
            fillColor: '525659',

            render_highlight: {
              fillOpacity: 0.8,
            },
            render_select: {
              fillOpacity: 0.8,
            },
            key: floors[a].id + '-' + 3,
            selected: true,
          });
          output.push({
            fillColor: 'af4c0f',
            render_highlight: {
              fillOpacity: 0.8,
            },
            render_select: {
              fillOpacity: 0.8,
            },
            key: floors[a].id + '-' + 2,
            selected: true,
          });
          output.push({
            fillColor: '598140',
            render_highlight: {
              fillOpacity: 0.8,
            },
            render_select: {
              fillOpacity: 0.8,
            },
            key: floors[a].id + '-' + 1,
            selected: true,
          });
        }
        return output;
      }

      $('#map').mapster({
        fillColor: 'b5ab95',
        fillOpacity: 0.8,
        clickNavigate: false,
        mapKey: 'data-key',
        areas: createAreas(),
      });
      $(window).resize(function () {
        $('img[usemap]').each(function () {
          $(this).mapster('resize', $(this).closest('.areal').width());
        });
      });
    });
  },
};
</script>

<style lang="scss"
       scoped>
.areal {
  position: relative;

  //   @media (max-width: 576px) {
  //     margin-top: 8rem;
  //     transform: scale(1.7) translateY(-33px);
  //   }

  &__img {
    width: 100%;
  }

  .h2 {
    position: absolute;
    left: 50%;
    top: 55px;
    transform: translateX(-50%);
    z-index: 5;
    color: white;

    @media (max-width: 991px) {
      top: 25px;
    }
    @media (max-width: 450px) {
      font-size: 1.5rem;
    }
  }
}
</style>
